import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const ComingSoon = () => {


    const navigate = useNavigate();
    const pageNavigate = (path) => {
        navigate(`/${path}`);

    };


    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-blue-300 via-indigo-500 to-blue-500 text-white p-6">
            <motion.div
                className="text-center"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <motion.h1
                    className="text-5xl font-bold mb-4"
                    initial={{ scale: 0.9 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    Amazing Features Are On Their Way!
                </motion.h1>
                <motion.p
                    className="text-lg mb-6"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                >
                    This page is currently under development. Stay tuned for something
                    awesome coming your way soon!
                </motion.p>
                <motion.img
                    src="./images/comingsoon-removebg-preview.png"
                    alt="Coming Soon"
                    className="w-full max-w-md mx-auto mb-6"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                />
                <motion.p
                    className="text-sm italic mb-8"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.7, duration: 0.8 }}
                >
                    "Great things are worth waiting for. We’re working hard to deliver a
                    delightful experience!"
                </motion.p>
                <motion.button
                    onClick={() => pageNavigate("")}
                    className="px-8 py-3 bg-white text-indigo-600 font-semibold rounded-lg shadow-lg hover:bg-gray-200 focus:outline-none"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Back to Home
                </motion.button>
            </motion.div>
        </div>
    );
};

export default ComingSoon;
